module.exports = new __parcel__URL__("absorption.43660af9.png").toString();